'use client';

import { useState, createContext, useCallback, useRef } from 'react';

import Alert from '../../components/Alert';
import uuid from '../../utils/uuid/uuid';
import { AlertItem } from '../../interfaces/alert/alert-item.interface';
import { AlertContextType, AlertProviderProps } from './alert-context.type';

import './AlertContext.scss';

export const AlertContext = createContext<AlertContextType | undefined>(
  undefined,
);

export const AlertProvider = ({ children }: AlertProviderProps) => {
  const alertsContext = useRef<AlertContextType>(null);
  const [alerts, setAlerts] = useState<AlertItem[]>([]);

  const remove = useCallback((alertId: string) => {
    setAlerts((_alerts) => _alerts.filter((_item) => _item.id !== alertId));
  }, []);

  const add = useCallback(
    (alert: AlertItem) => {
      const newAlert = {
        ...alert,
        id: alert.id ?? uuid(),
      };

      newAlert.onExited = () => {
        remove(newAlert.id);
      };

      setAlerts((prev) => [...prev, newAlert]);
    },
    [alerts],
  );

  alertsContext.current = {
    add,
    remove,
    alerts,
  };

  return (
    <AlertContext.Provider value={alertsContext.current}>
      {children}
      <div className='alert-context'>
        {alerts.map((item: AlertItem) => (
          <Alert
            className='alert-context-snackbar'
            closeButtonLabel={item.closeButtonLabel}
            content={item.content}
            id={item.id}
            key={item.id}
            onClose={item.onClose}
            onExited={item.onExited}
            permanent={item.permanent}
            timeout={item?.timeout}
            title={item.title}
            variant={item.variant}
          />
        ))}
      </div>
    </AlertContext.Provider>
  );
};
